require('./angular');
module.exports = angular;



// WEBPACK FOOTER //
// ./~/angular/index.js